!(function (t, a) {
    function e(t) {
        (this.baseUrl = "https://cdn.shopify.com/s/files/1/2220/8601/files/"), (this.domain = t.replace(".myshopify.com", "")), (this.productSwatches = []), (this.productsPerRow = 4);
    }
    (e.prototype.setProductsPerRow = function (t) {
        this.productsPerRow = t;
    }),
        (e.prototype.productHasColorOption = function (t) {
            if (!window.isValue(t.options_with_values)) return !1;
            for (var a = 0; a < t.options_with_values.length; a++) {
                if ("color" === t.options_with_values[a].name.toLowerCase()) return !0;
            }
            return !1;
        }),
        // (e.prototype.parseSwatchify = function (t) {
        //     return t
        // }),
        (e.prototype.addProductSwatchBox = function (t, a) {
            this.productSwatches[t] = a;
        }),
        (e.prototype.getSwatchesJson = function (t) {
          console.log(t.swatches);
            if (!1 === window.isValue(t.swatches))return !1;
            var a = t.swatches;
          console.log(a.length);
            return !(a.length < 2) && a;
        }),
        (e.prototype.swapProductSwatchBox = function (a, e) {
            if (!window.isValue(this.productSwatches[e])) return !1;
            for (var r = t(a), o = t(this.productSwatches[e]), c = r.find(".product_item_swatches").detach(), s = [1, 2, 3], i = 0; i < s.length; i++) o.removeClass("per-" + s[i] + "-row");
            o.addClass("per-" + this.productsPerRow + "-row"), r.replaceWith(o), c.appendTo(o.find(".info"));
        }),
        // (e.prototype.buildProductGridItem = function (a) {
        //     if (!window.isValue(bcSfFilterConfig.shop)) return !1;
        //     var e = "/products/" + t(a).attr("data-handle"),
        //         r = this;
        //     $.get(e, { view: "swatch" }, function (a) {
        //         var e = $.parseJSON(a),
        //             o = r.getSwatchesJson(e);
        //         if (!window.isValue(o)) return !1;
        //         for (var c = t('.products_grid_item[data-handle="' + e.handle + '"]').find(".info"), s = t('<ul class="product_item_swatches">'), i = 0; i < o.length; i++) {
        //             var n = o[i],
        //               e = t(a).attr("data-value").substring("Color-".length),
        //                 l = n.image['url'],
        //                 p = t("<li>"),
        //                 d = t("<a>");
        //          console.log('ee' + n.color);
        //             d.attr("data-handle", n.handle),
        //                 d.attr("href", n.url),
        //                 d.css("background-color", n.color),
        //                 d.css("background-image", "url(" + l + ")"),
        //                 p.append(d),
        //                 s.append(p),
        //                 p.find("a").on("click", function (a) {
        //                     a.preventDefault();
        //                     var e = t(this).closest(".products_grid_item[data-handle]");
        //                     if (!window.isValue(e)) return !1;
        //                     r.swapProductSwatchBox(e, t(this).attr("data-handle"));
        //                 }),
        //                 window.isValue(n.productFilterData) && r.addProductSwatchBox(n.handle, bcsffilter.buildProductGridItem(n.productFilterData));
        //         }
        //         c.append(s);
        //     });
        // }),
        (e.prototype.buildProductSwatchBox = function (a) {
          
            var e = "/products/" + a,
                r = this;
          
            $.get(e, { view: "swatch" }, function (a) {
                var e = $.parseJSON(a),
                    o = r.getSwatchesJson(e);
              console.log(e);
              console.log('check 3');
              console.log(o);
                if (!window.isValue(o)) return !1;
                for (var c = t('<div class="product_item_swatch_color">'), s = t('<ul class="product_item_swatches">'), i = 0; i < o.length; i++) {
                    var n = o[i],
                        l = 'https://cdn.shopify.com/s/files/1/2220/8601/files/' + n.color.replace(/\s+/g, '-') + '.png',
                        p = t('<li class="swatch">'),
                        d = t('<a class="swatch_link">');
                  console.log('https://cdn.shopify.com/s/files/1/2220/8601/files/' + n.color.replace(/\s+/g, '-') + '.png');
                    d.attr("data-handle", n.handle),
                        d.attr("data-option-name", n.option_name),
                        d.attr("href", n.url),
                        d.css("background-color", n.color),
                        d.css("background-image", "url(" + l + ")"),
                        d.text(n.color),
                        p.append(d),
                        s.append(p);
                  console.log('n' + n.image['url']);
                }
                var u = o[0].color,
                    h = o[0].option_name;
                c.html('<p><span class="label">' + h + ': </span><span class="current_swatch">' + u + "</span></p>"), s.find("li:first").addClass("active");
                var w = t(".product_related_swatches");
                w.append(c),
                    w.append(s),
                    t(".swatch").hover(
                        function () {
                            t(".product_item_swatch_color .current_swatch").text(t(this).text()), t(".product_item_swatch_color span.label").text(t(this).find(".swatch_link").data("option-name") + ": ");
                        },
                        function () {
                            t(".product_item_swatch_color .current_swatch").text(u), t(".product_item_swatch_color span.label").text(h + ": ");
                        }
                    );
            });
        }),
        (window.swatchBox = new e(a.shop));
})(window.jQuery, window.Shopify);
